<template>
  <div class="notification-card">
    <div class="notification-card__spinner" v-if="spinner">
      <LoadingIndicator />
    </div>
    <div class="notification-card__title" v-if="hasSlot.title">
      <slot name="title" />
    </div>
    <div class="notification-card__actions" v-if="hasSlot.actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoadingIndicator from '@components/common/LoadingIndicator.vue';
import { hasSlotContent } from '@components/slots';

export default defineComponent({
  name: 'NotificationCard',

  components: {
    LoadingIndicator,
  },

  props: {
    spinner: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    hasSlot() {
      return {
        actions: hasSlotContent(this.$slots.actions, {}),
        title: hasSlotContent(this.$slots.title, {}),
      };
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';
.notification-card {
  border-radius: settings.$border-radius;
  background: colors.$color-grey-blue-100;
  display: flex;
  color: colors.$color-white;
  height: 64px;
  padding: 0 16px 0 24px;
  align-items: center;
  pointer-events: all;
  justify-self: end;

  transition: all 0.3s ease-in-out;
  max-width: settings.$notification-max-width;
  right: 0;
}

.notification-card__spinner {
  padding-right: 8px;
}

.notification-card__title {
  flex: 1 1 auto;

  @include typography.typography-15-normal;
  @include typography.typography-baseline-alignment;
}

.notification-card__actions {
  padding-left: 24px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
}
</style>
